import { BlockReasons } from '../models/user/user';

/**
 * Cleans the retrieved students by removing students who left school
 * @param {Array} students - Array of student objects
 * @returns {Array} - Filtered array of students
 */
export const cleanStudents = (students) => {
  if (!Array.isArray(students)) return [];
  
  return students.filter(student => {
    // Remove students who are blocked with LEAVE_SCHOOL reason
    if (student.blocked && student.blockReason === BlockReasons.LEAVE_SCHOOL) {
      return false;
    }
    return true;
  });
};

/**
 * Gets the status information for a student
 * @param {Object} student - Student object
 * @param {Object} baseColors - Base color theme
 * @param {boolean} isDark - Dark mode flag
 * @returns {Object} - Status object with label, color, and bgColor
 */
export const getStudentStatus = (student, baseColors, isDark) => {
  if (!student.blocked) {
    return {
      label: 'Active',
      color: baseColors.success,
      bgColor: isDark ? 'bg-green-900' : 'bg-green-100'
    };
  }

  switch (student.blockReason) {
    case BlockReasons.DISMISSED:
      return {
        label: 'Dismissed',
        color: baseColors.error,
        bgColor: isDark ? 'bg-red-900' : 'bg-red-100'
      };
    case BlockReasons.FEE_DUE:
      return {
        label: 'Fee Due',
        color: baseColors.warning,
        bgColor: isDark ? 'bg-yellow-900' : 'bg-yellow-100'
      };
    case BlockReasons.OTHER:
      return {
        label: 'Blocked',
        color: baseColors.error,
        bgColor: isDark ? 'bg-gray-900' : 'bg-gray-100'
      };
    default:
      return {
        label: 'Blocked',
        color: baseColors.error,
        bgColor: isDark ? 'bg-gray-900' : 'bg-gray-100'
      };
  }
}; 